/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import { useConfirmingLeave } from "@lhd/app/index";
import Button from "@lhd/components/Button";
import {
  BUTTON_HEIGHT,
  CopyTypeAppStore,
  FONT_SIZE,
  FONT_SIZE_VALUE,
  getFileNameFromURL,
} from "@lhd/constants";
import { App, DISPLAY_SIZES } from "@lhd/types";
import { Col, notification, Row } from "antd";
import { FormikProps } from "formik";
import { cloneDeep, uniqBy } from "lodash";
import { useContext, useEffect, useRef, useState } from "react";
import { useMatch, useSearchParams } from "react-router-dom";
import { createFieldCode, generateUuid } from "../utils";
import AppFormEditor from "./AppFormEditor";
import AppTable from "./components/AppTable";
import TagItem from "./components/TagItem";
import {
  APP_PART_TYPES,
  GROUP_AS_COLORS,
  DEFAULT_WIDTH_COL,
  TAGS,
} from "./constants";
import { Props } from "./hook";
import { FormActionContext } from "./index";
import { Styles } from "./styled";
import type { AppPartType } from "./types";
import { useSelector } from "react-redux";
import { getDisplaySize } from "@lhd/components/DisplaySizeSelector/selector";

interface IProps extends Props {
  appData?: App;
  form?: FormikProps<any>;
  isPreview?: boolean;
  setIsPreview?: React.Dispatch<React.SetStateAction<boolean>>;
  isLoading?: boolean;
}

const AppFormLayout: React.FC<IProps> = ({
  appData,
  form,
  isPreview,
  setIsPreview,
  isLoading,
}) => {
  // const matchCreateApp = useMatch("/apps/create");
  // const matchApp = useMatch("/apps/:id");
  const matchAppTable = useMatch("/apps/:id/app-table");
  const selectedItemRef = useRef<any | null>(null);
  const elDistanceToTopRef = useRef(0);
  const elTableDragRef = useRef<HTMLDivElement | null>(null);

  const { contextState, setContextState } = useContext(FormActionContext);
  const { checkLeaveForm } = useConfirmingLeave();

  const [searchParams] = useSearchParams();
  const tabParams = searchParams.get("tab");

  const isShowEditApp = !!matchAppTable || tabParams === "app-table";
  const [imageApp, setImageApp] = useState<any>();
  const [isDragging, setIsDragging] = useState(false);
  const [listSelectedCategory, setListSelectedCategory] = useState<number[]>();
  const isAllowUpdateApp =
    appData?.current_detail_permissions?.specified_app_edit ||
    appData?.current_detail_permissions?.specified_app_delete;

  // const appCategoryOptions = dataAppCategories?.data?.map((categoryItem) => ({
  //   value: categoryItem?.id,
  //   label: categoryItem?.name,
  // }));

  // const handleSelectCategories = (val: number[]) =>
  //   setListSelectedCategory(val);

  const displaySize = useSelector(getDisplaySize) as
    | keyof typeof FONT_SIZE
    | keyof typeof BUTTON_HEIGHT;
  const height = BUTTON_HEIGHT[displaySize] ?? BUTTON_HEIGHT.small;
  const size = FONT_SIZE_VALUE[displaySize ?? DISPLAY_SIZES.SMALL];

  useEffect(() => {
    if (appData) {
      if (appData?.picture_original_url && imageApp === undefined) {
        setImageApp({
          name: getFileNameFromURL(appData?.picture_original_url),
          picture_original_url: appData?.picture_original_url,
        });
      }

      if (appData?.app_parts) {
        setContextState((draft) => {
          draft.layout = appData.app_parts;
        });
      }

      if (
        !listSelectedCategory &&
        appData?.app_categories &&
        Number(appData?.app_categories?.length) > 0
      ) {
        setListSelectedCategory(
          appData?.app_categories?.map((category) => category.id),
        );
      }
    }
  }, [appData, setContextState, imageApp, listSelectedCategory]);

  const onAddNewColumn = () => {
    checkLeaveForm();

    setContextState((draft) => {
      let maxHeightItemApp = 0;
      draft?.layout.forEach((l: AppPartType) => {
        if (l.item_config_data.y + l.item_config_data.h > maxHeightItemApp) {
          maxHeightItemApp = l.item_config_data.y + l.item_config_data.h;
        }
      });

      let newItem: AppPartType = {} as AppPartType;
      const firstItem = draft?.layout?.[0];
      if (firstItem) {
        const clonedAppPart = cloneDeep(firstItem);
        const tag = TAGS.find((x) => x.app_part_type === APP_PART_TYPES.TEXT);
        newItem = {
          app_part_type: APP_PART_TYPES.TEXT,
          id: undefined,
          uuid: generateUuid(),
          name: tag?.name,
          item_config_data: {
            ...clonedAppPart.item_config_data,
            parentI: undefined,
            i: generateUuid(),
            x: 0,
            y: maxHeightItemApp,
          },
          width: DEFAULT_WIDTH_COL,
        } as AppPartType;
      } else {
        const tag = TAGS.find((x) => x.app_part_type === APP_PART_TYPES.TEXT);
        newItem = {
          app_part_type: APP_PART_TYPES.TEXT,

          id: undefined,
          uuid: generateUuid(),
          name: tag?.name,
          item_config_data: {
            i: generateUuid(),
            x: 0,
            y: 1,
            ...tag?.item_config_data,
          },
          width: DEFAULT_WIDTH_COL,
        } as AppPartType;
      }
      newItem.field_code = createFieldCode(newItem.name, contextState.layout);
      draft.layout = [newItem, ...draft.layout];
    });
  };

  // const navigateToEditField = () =>
  //   navigate(`/apps/${match?.params.id}/records?isEdit=true`);

  // const navigateToRecordPermission = () =>
  //   navigate(`/apps/${match?.params.id}/record-permission`);
  useEffect(() => {
    if (elTableDragRef.current) {
      const elDistanceToTop =
        elTableDragRef.current.getBoundingClientRect().top;
      elDistanceToTopRef.current = elDistanceToTop;
    }
  }, [elTableDragRef.current]);

  const dataTagMaps = uniqBy(TAGS, "app_part_type").reduce((acc, cur) => {
    const keyTypeGroup = cur.group_type || GROUP_AS_COLORS.typeColumns.type;
    if (!acc[keyTypeGroup]) acc[keyTypeGroup] = [cur];
    else {
      acc[keyTypeGroup].push(cur);
    }
    return acc;
  }, {} as { [key: string]: AppPartType[] });

  return (
    <Styles text_scale={displaySize}>
      {isShowEditApp && contextState?.layout?.length === 0 && (
        <div className="wrap-button-add-column">
          <Button
            onClick={onAddNewColumn}
            label="列追加"
            style={{
              fontSize: size,
              height: height,
              width: "fit-content",
            }}
            displaySize={displaySize}
          />
        </div>
      )}
      {/* {matchCreateApp && <AppFormInformation form={formik} />} */}
      {!isShowEditApp && (
        <div className="table-drag-n-drop" ref={elTableDragRef}>
          <Row>
            <Col
              span={3}
              style={{
                height: `calc(100vh - ${elDistanceToTopRef.current}px)`,
              }}
            >
              <div className="item1">
                {Object.keys(GROUP_AS_COLORS).map((key) => {
                  return (
                    <div
                      key={key}
                      style={{
                        borderBottom: "1px solid #ccc",
                        paddingRight:
                          GROUP_AS_COLORS[key as keyof typeof GROUP_AS_COLORS]
                            .type !== GROUP_AS_COLORS.typeColumns.type
                            ? 16
                            : 0,
                      }}
                      className={
                        GROUP_AS_COLORS[key as keyof typeof GROUP_AS_COLORS]
                          .type
                      }
                    >
                      <div className="name_group">
                        {
                          GROUP_AS_COLORS[key as keyof typeof GROUP_AS_COLORS]
                            .name
                        }
                      </div>
                      <div>
                        {dataTagMaps[key].map((tag, index) => {
                          return (
                            <div
                              key={`${tag.name}_${index}`}
                              onMouseDown={() => {
                                if (
                                  appData?.copy_type ===
                                  CopyTypeAppStore.syncConfigFromOriginal
                                ) {
                                  notification.error({
                                    message:
                                      "こちらは改変不可・自動更新Bizシートです",

                                    duration: 3,
                                  });
                                  setIsDragging(false);
                                  selectedItemRef.current = null;
                                } else {
                                  selectedItemRef.current = tag;
                                  setIsDragging(true);
                                }
                              }}
                              onMouseUp={() => setIsDragging(false)}
                              style={{ color: "red" }}
                            >
                              <TagItem
                                tag={tag}
                                onDragStart={(e) => {
                                  const newFieldCode = createFieldCode(
                                    tag.name,
                                    contextState.layout,
                                  );
                                  tag.field_code = newFieldCode;
                                  tag.current_detail_permissions = {
                                    specified_app_part_edit: true,
                                    specified_app_part_read: true,
                                    add_new_app_part: true,
                                  };

                                  e.dataTransfer.setData(
                                    "text/plain",
                                    tag.app_part_type,
                                  );
                                }}
                                onDragEnd={() => setIsDragging(false)}
                                style={{
                                  minHeight: height,
                                }}
                              />
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>
            </Col>

            <Col
              span={21}
              style={{
                border: "8px solid #f0f2f5",
                height: `calc(100vh - ${elDistanceToTopRef.current}px)`,
              }}
            >
              <div className="item2 container-sub_gird-layout">
                <AppFormEditor
                  ref={selectedItemRef}
                  appCopyType={
                    appData?.copy_type as keyof typeof CopyTypeAppStore
                  }
                  layout={contextState.layout}
                  isPreview={isPreview}
                  setIsPreview={setIsPreview}
                  isDragging={isDragging}
                />
              </div>
            </Col>
          </Row>
        </div>
      )}
      {isShowEditApp && (
        <AppTable
          appCopyType={appData?.copy_type as keyof typeof CopyTypeAppStore}
          layout={contextState.layout}
          isAllowUpdateApp={isAllowUpdateApp}
        />
      )}
    </Styles>
  );
};

export default AppFormLayout;
